import components from './components';
import views from './views';
import common from './common';
import router from './router';

export default {
	components,
	views,
	common,
	router
};
